import { render, staticRenderFns } from "./visitorRecord.vue?vue&type=template&id=1d7055a8&scoped=true&"
import script from "./visitorRecord.vue?vue&type=script&lang=js&"
export * from "./visitorRecord.vue?vue&type=script&lang=js&"
import style0 from "./visitorRecord.vue?vue&type=style&index=0&id=1d7055a8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7055a8",
  null
  
)

export default component.exports